import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../../action-button';
import { useEditorHeaderContext } from '../context';
import withPopover from '../hoc/with-popover';

const PublishButton = ({ label, ...props }) => {
  const { isLg } = useEditorHeaderContext();

  return (
    <ActionButton
      {...props}
      label={isLg ? label : null}
      iconPlacement="before"
      iconGlyph={isLg ? null : 'publish'}
      format="solid"
      size="small"
      appearance="accent"
    />
  );
};

PublishButton.propTypes = {
  label: PropTypes.string.isRequired,
};

export default withPopover(PublishButton);
